import { render } from "./HeroSection.vue?vue&type=template&id=d424753e&scoped=true&ts=true"
import script from "./HeroSection.vue?vue&type=script&lang=ts"
export * from "./HeroSection.vue?vue&type=script&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=d424753e&lang=scss&scoped=true"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d424753e"]])

export default __exports__